import { Check } from "lucide-react";
import { WHY_US } from "../../data/content";

export default function WhyUs() {
  return (
    <section
      data-testid="why-us"
      className="py-20 md:py-32 bg-ink-mist border-t border-ink-line"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-start">
          <div className="md:col-span-5">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Why Urban Painter
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              Quality is a process,
              <br />
              <span className="font-serif-italic font-normal text-ink-mid">
                not a promise.
              </span>
            </h2>
            <p className="mt-6 text-ink-muted leading-relaxed max-w-md">
              Urban Painter has been serving customers across Gurugram and Delhi
              NCR since 2019. We keep the process consistent and the workmanship
              clean.
            </p>
          </div>

          <ul className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-ink-line border border-ink-line">
            {WHY_US.map((item, i) => (
              <li
                key={item}
                data-testid={`why-us-item-${i}`}
                className="bg-white p-5 md:p-6 flex items-start gap-3"
              >
                <span className="mt-0.5 w-6 h-6 grid place-items-center bg-ink text-white shrink-0">
                  <Check size={12} strokeWidth={3} />
                </span>
                <span className="text-sm md:text-base text-ink leading-snug">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
